import { Routes, Navigate, Route } from 'react-router-dom';
import { DashboardLayout } from '../components/Layout';
import PrivateLayoutRoute from './PrivateLayoutRoute';
import {
  SignIn,
  WelcomeView,
  TeamVacationRequestsView,
  DashboardView,
  VacationsView,
  TeamMembersView,
  OutOfOfficesView,
  HardwareRequestsView,
  TeamHardwareRequestsView,
  CalendarView,
  EducationBudgetRequestView,
  TeamEducationBudgetRequestView,
  PrivacyPolicyView,
} from '../views';
import { useAuth } from '../auth';

const AppRoutes = () => {
  const { isSignedIn } = useAuth();
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route
        path="/signin"
        element={isSignedIn ? <Navigate to="/dashboard" replace /> : <SignIn />}
      />
      <Route
        path="/welcome"
        element={isSignedIn ? <WelcomeView /> : <Navigate to="/signin" replace />}
      />
      <Route
        path="/dashboard"
        element={
          <PrivateLayoutRoute
            layout={DashboardLayout}
            component={DashboardView}
            viewName="Dashboard"
          />
        }
      />
      <Route
        path="/team-vacation-requests"
        element={
          <PrivateLayoutRoute
            layout={DashboardLayout}
            component={TeamVacationRequestsView}
            viewName="Team Vacation Requests"
            manager
            excludeOfficeManager
          />
        }
      />
      <Route
        path="/my-vacation-requests"
        element={
          <PrivateLayoutRoute
            layout={DashboardLayout}
            component={VacationsView}
            viewName="My Vacation Requests"
          />
        }
      />
      <Route
        path="/my-out-of-office"
        element={
          <PrivateLayoutRoute
            layout={DashboardLayout}
            component={OutOfOfficesView}
            viewName="My Out of Office Requests"
          />
        }
      />
      <Route
        path="/my-education-budget"
        element={
          <PrivateLayoutRoute
            layout={DashboardLayout}
            component={EducationBudgetRequestView}
            viewName="My Education Budget"
          />
        }
      />
      <Route
        path="/my-hardware-requests"
        element={
          <PrivateLayoutRoute
            layout={DashboardLayout}
            component={HardwareRequestsView}
            viewName="My Hardware Requests"
          />
        }
      />
      <Route
        path="/team-members"
        element={
          <PrivateLayoutRoute
            layout={DashboardLayout}
            component={TeamMembersView}
            viewName="Team Members"
            manager
            excludeOfficeManager
          />
        }
      />
      <Route
        path="/team-hardware-requests"
        element={
          <PrivateLayoutRoute
            layout={DashboardLayout}
            component={TeamHardwareRequestsView}
            viewName="Team Hardware Requests"
            manager
            hardwareManager
          />
        }
      />
      <Route
        path="/team-education-budget-requests"
        element={
          <PrivateLayoutRoute
            layout={DashboardLayout}
            component={TeamEducationBudgetRequestView}
            viewName="Team Education Budget"
            manager
            hardwareManager
          />
        }
      />
      <Route
        path="/calendar"
        element={
          <PrivateLayoutRoute
            layout={DashboardLayout}
            component={CalendarView}
            viewName="Calendar"
          />
        }
      />
      <Route
        path="/privacy-policy"
        element={
          <PrivateLayoutRoute
            layout={DashboardLayout}
            component={PrivacyPolicyView}
            viewName="Privacy Policy"
          />
        }
      />
    </Routes>
  );
};

export default AppRoutes;
